import React from 'react';
export function Footer() {
  return <footer className="bg-white text-gray-600 py-12 px-4 text-center border-t-4 border-pink-100" data-id="element-81">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-82">
        <img src="https://cdn.magicpatterns.com/uploads/aN6ks29GoLPpFpEATNCjtf/Logo_mundo_deco.png" alt="Mundo Deco Logo" className="h-20 mb-6" data-id="element-83" />

        <p className="mb-4 font-medium text-gray-500" data-id="element-84">
          © {new Date().getFullYear()} Kit Fiesta Mágica — Mundo Deco Digital ·
          Todos los derechos reservados
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400" data-id="element-85">
          <span data-id="element-86">Contacto: mundoinfantildigital10@gmail.com</span>
          <span className="hidden md:inline" data-id="element-87">·</span>
          <span data-id="element-88">Instagram: @mundodecodigital</span>
        </div>
      </div>
    </footer>;
}